import React, {Component} from 'react';
import {Alert} from 'reactstrap';
import Dropzone from 'react-dropzone'
import SweetAlert from 'react-bootstrap-sweetalert';
import ReactLoading from 'react-loading';
import {request} from "../../../helper/APIUtils";

class DocumentViewer extends Component {

  constructor(props) {
    super(props);

    this.onDrop = this.onDrop.bind(this);

    this.state = {
      loading: false,
      documentUrl: null,
      documentXml: null
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.value !== this.props.value) {
      this.load();
    }
  }

  load() {

    if (!this.props.value || !this.props.value.content || !this.props.value.contentType) {
      this.setState({
        documentUrl: null,
        documentXml: null
      });
      return;
    }

    this.setState({
      loading: true
    });

    let formData = new FormData();
    let fileContent = new Blob([this.props.value.content], {type: this.props.value.contentType})
    formData.append("document", fileContent);

    let params = {
      url: "/signature/general/xmlToHtml",
      method : 'post',
      data : formData,
      responseType: 'blob'
    };

    request(params)
      .then(response => {
        let urlCreator = window.URL || window.webkitURL;
        let url = urlCreator.createObjectURL(response.data);
        this.setState({
          documentUrl: url
        });
      })
      .catch(error => {
        this.setState({
          documentXml: "Dosya imzasını yukarıdaki \"İmza Doğrula\" butonuna tıklayarak doğrulayabilirsiniz."
        });
      })
      .finally(() => {
        this.setState({
          loading: false
        });
      });
  }

  onDrop(acceptedFiles, rejectedFiles) {
    if (rejectedFiles && rejectedFiles.length) {
      this.setState({
        alert: <SweetAlert error
                           confirmBtnText="Tamam"
                           confirmBtnBsStyle="error"
                           title="Hata"
                           onConfirm={() => this.setState({alert: null})}>
          Hatalı dosya türü.
        </SweetAlert>
      });
      return;
    }

    if (!acceptedFiles || !acceptedFiles[0])
      return;

    let file = acceptedFiles[0];
    let fileName = file.name;
    let fileExtension = fileName.slice(fileName.lastIndexOf('.') + 1, fileName.leading) || fileName;
    fileExtension = fileExtension.toLowerCase();

    let contentType;

    if (fileExtension === 'xml')
      contentType = 'application/xml';
    else if (fileExtension === 'pdf')
      contentType = 'application/pdf'
    else
      throw "Invalid file extension";

    this.setState({
      loading: true
    });

    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onload = () => {
      this.props.onChange({content: fileReader.result, contentType: contentType, fileName: fileName});
    };
  }

  renderDropZone() {
    return <Dropzone
      accept=".xml,.pdf"
      className="FormRenk col-sm-12"
      activeClassName="dropzoneActiveClass"
      style={{marginTop: '15px'}}
      multiple={false}
      onDrop={this.onDrop}>
      <div className="dropzoneInnerArea">
        Dosyaları buraya sürekleyiniz.
      </div>
    </Dropzone>
  }

  renderDocument() {
    return <iframe src={this.state.documentUrl} style={{width: "100%", height: "500px"}}/>
  }

  renderXml() {
    return <Alert color="info">{this.state.documentXml}
    </Alert>
  }

  render() {

    return <div>
      {this.state.alert}
      {this.state.loading && <ReactLoading type="spinningBubbles" style={{width:"90px", height: "90px", margin: "10px auto 10px auto", fill: "#888"}}/>}
      {!this.state.loading && !this.state.documentUrl && !this.state.documentXml && this.renderDropZone()}
      {!this.state.loading && this.state.documentUrl && this.renderDocument()}
      {!this.state.loading && this.state.documentXml && this.renderXml()}
    </div>
  }
}

export default DocumentViewer;
